export enum LogLevelType {
  Debug,
  Info,
  Warning,
  Error,
  Custom,
  Table,
}
